import styled from "styled-components";

export const Container = styled.div`
    input{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
    border-radius: 4px;
    padding: 10px;
    width: 100%;

    &:focus-within {
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colors.primary};
        box-shadow: 0 0 0 3px ${(props) => props.theme.colors.gray.gray_50};
        transform: translateY(-1px);
    }
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;

    overflow-y: auto;
    max-height: 90%;
`;

export const Button = styled.button`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;

    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    
    &.active{
        font-weight: 500;
        border-left: 2px solid ${(props) => props.theme.colors.primary};
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
`;

export const ButtonPayment = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    
    width: 100%;
    height: 50px;
    padding: 10px;
    border-radius: 4px;
    
    &.active{
        font-weight: 500;
        border-left: 2px solid ${(props) => props.theme.colors.primary};
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
`;

export const ButtonClose = styled.button`
    display: flex;
    background-color: transparent;
    color: ${(props) => props.theme.colors.gray.gray_500};
    &:hover{
        color: ${(props) => props.theme.colors.primary};
    }
`;

export const ContentButton = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 4px;
    width: 100%;
`;

export const ContentInfor = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed ${(props) => props.theme.colors.gray.gray_100};  

    &.no-border{
        border: none;
    }
`;

export const DescriptionPayment = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px dashed ${(props) => props.theme.colors.gray.gray_100};
`;

export const ContentInput = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;

    &.content-column{
        flex-direction: column;
    }
`;

export const ContentPayment = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    &.content-color{
        border: 1px dashed ${(props) => props.theme.colors.gray.gray_100};
        padding: 4px 8px;
        border-radius: 4px;
    }
`;

export const CheckBox = styled.input`
  width: 18px;
  height: 18px;
  appearance: none;
  cursor: pointer;

  border-radius: 30px;
  border: 1px solid ${(props) => props.theme.colors.gray.gray_100};

  &:checked {
    background-color: ${(props) => props.theme.colors.primary};
    border-color: ${(props) => props.theme.colors.primary}; /* Borda ao marcar */
  }

  &:hover {
    border-color:${(props) => props.theme.colors.primary}; /* Cor ao passar o mouse */
  }

  &::after {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    margin: 3px auto;
    color: ${(props) => props.theme.colors.white};
    opacity: 0;
    transition: opacity 0.2s ease;
  }
`;

export const Description = styled.span`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    &.padding{
        padding: 0px 6px;
    }
    
    &.active{
        color: ${(props) => props.theme.colors.error};
    }
`;

export const SeparateDiv = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    width: 100%;
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    input{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
        padding: 10px;
        width: 100%;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const listButton = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const listButtonPay = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;

    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
    border-radius: 4px;
    padding: 10px;
    width: 100%;

    &:focus-within {
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colors.primary};
        box-shadow: 0 0 0 3px ${(props) => props.theme.colors.gray.gray_50};
        transform: translateY(-1px);
    }
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const Infor = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 100%;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const highliInfor = styled.p<{ isActive: boolean }>`
    background-color: ${(props) => props.isActive ? 'rgba(36, 186, 91, 0.15)' : props.theme.colors.gray.gray_50};
    color: ${(props) => props.isActive ? props.theme.colors.success : props.theme.colors.gray.gray_500};
    border-radius: 4px;
    padding: 3px;
`;

export const Footer = styled.footer`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    padding: 4px 8px;
    border-radius: 4px;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const Title = styled.button<{ isOpen: boolean }>`
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 500;

    color: ${(props) => props.isOpen ?
        props.theme.colors.gray.gray_800 :
        props.theme.colors.gray.gray_200
    };
    background-color: transparent;
`;

export const TitleButton = styled.p``;

export const Text = styled.p`
    font-weight: 500;
    color: ${(props) => props.theme.colors.gray.gray_800};
    
    &.subtitle{
        font-weight: normal;
        color: ${(props) => props.theme.colors.gray.gray_500};
        font-size: 14px;
    }
    
    &.subtitle-full{
        font-weight: 500;
        color: ${(props) => props.theme.colors.gray.gray_800};
        font-size: 14px;
    }
    
    &.warning{
        border-left: 2px solid ${(props) => props.theme.colors.primary};
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        padding: 2px 4px;
        border-radius: 4px;
        color: ${(props) => props.theme.colors.primary};
        font-size: 14px;
        font-weight: normal;
    }
`;
